import React, { useEffect, useRef, useState } from "react";
import { useAppSelector } from "../../../../redux/store";
import Message from "../../../components/message";
import { MessageSections } from "../../../components/message/message";
import { OrderModel } from "../../../shared/models/order/order-item.model";
import BarekamText from "../../../components/text";
import moment from "moment";
import { PaymentDetailsBlock, PaymentDetailsContainer, PaymentDetailsRightBlock } from "./styled";
import { OrderPaymentStatusEnum } from "../../enums/order-payment-status.enum";
import { OrderPopupCardTitle } from "../styled";
import BarekamButton, { OrderButtons, SimpleButtons } from "../../../components/button";
import { CurrencyModel } from "../../../../redux/reducers/static-data.reducers";
import BarekamChip from "../../../components/chip/barekamChip";
import { useOutletContext } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import { BarekamIcon } from "../../../components/icon/barekam-icon";
import { OrderIcons } from "../../../components/icon/variants";
import { useReactToPrint } from "react-to-print";
import { GapContainer } from "../../../components/card/styled";
import Template from "../../../../management-pages/template-generator/Template";
import { WarningDialog } from "../../../components/dialogs/warning-dialog";
import { OutletContext } from "../../../../router/router";
import { OrderPaymentStatusNames } from "../../../../actions/types";
import PayConfirmDialog from "../../my/order-list/pay-confirm-dialog";

const PaymentDetails = (props: PaymentDetailsProps) => {
    const { order, loadAndSetOrder } = props;
    const { languageId } = useAppSelector(state => state.messagesReducer);
    const { matchesPhone } = useAppSelector(state => state.deviceReducer);

    const [popupOpened, setPopupOpened] = React.useState(false);
    const [confirmPopup, setConfirmPopup] = React.useState(false);
    const [paymentAmount, setPaymentAmount] = useState<{
        additionalServices: string,
        currency: CurrencyModel | undefined,
        total: string
    }>({ additionalServices: '', currency: undefined, total: '' });
    const outletContext = useOutletContext<OutletContext>();

    const componentRef = useRef<HTMLDivElement>(null);

    const isPaid = order.paymentStatus?.paymentStatusId === 2;
    const isPaidStatus: OrderPaymentStatusNames = order.paymentStatus?.name as OrderPaymentStatusNames || OrderPaymentStatusNames.UNPAID;
    const isInFinalState = ['entered', 'received'].includes(order.trackRecord[0].state.name);

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    useEffect(() => {
        setPaymentAmount(() => {
            if (order.paymentInfo) {
                const discount = order?.paymentInfo?.appliedDiscount || 0;

                if (order.additionalService.length) {
                    const additionalServiceAmount = order.additionalService.reduce(
                        (previousValue, currentValue) => previousValue + currentValue.price, 0);

                    return {
                        additionalServices: `${additionalServiceAmount}`,
                        currency: order.paymentInfo.shippingAmountCurrency,
                        discount: order.paymentInfo.appliedDiscount || 0,
                        total: `${(order.paymentInfo.appliedDiscount || 0) + additionalServiceAmount}`
                    }
                } else {
                    return {
                        additionalServices: '0',
                        currency: order.paymentInfo.shippingAmountCurrency,
                        discount: order.paymentInfo.appliedDiscount || 0,
                        total: `${order.paymentInfo.shippingAmount - discount}`
                    }
                }
            } else {
                return {
                    additionalServices: '',
                    currency: undefined,
                    total: ''
                }
            }
        })
    },
        [order.additionalService]
    )

    function onActionClick() {
        handlePrint();
    }

    function onSuccessfulPayment() {
        setPopupOpened(true);
        loadAndSetOrder();
    }

    function payHandler() {
        setConfirmPopup(true);
    }

    return (
        <PaymentDetailsContainer>
            <div style={{ display: 'none' }}>
                <Template ref={componentRef} variant={isPaidStatus} order={order} />
            </div>

            <OrderPopupCardTitle>
                <BarekamText variant={'m'} bold>
                    <Message messageKey={'payment_details'} sectionId={MessageSections.ORDERS} />
                </BarekamText>

                {isInFinalState || isPaid || outletContext.isWarehouseWorker || outletContext.isAdmin
                    ? <></>
                    : <BarekamButton type={OrderButtons.PAY_NOW}
                        onClick={payHandler}>
                        <BarekamText variant={'m'} bold overflow={'unset'} width={'unset'}>
                            <Message messageKey={'pay_now'} sectionId={MessageSections.ORDERS} />
                        </BarekamText>
                    </BarekamButton>
                }
            </OrderPopupCardTitle>

            <div style={{ display: 'flex', flexDirection: matchesPhone ? 'column' : 'row' }}>
                <PaymentDetailsBlock>
                    <div style={{ display: 'flex', gap: '0.25rem' }}>
                        <BarekamText variant={"m"} width={'unset'} overflow={'unset'} opaque>
                            <Message messageKey={'status'} sectionId={MessageSections.ORDERS} />:
                        </BarekamText>
                        {
                            order.paymentStatus
                                ? <>
                                    <BarekamChip messageKey={order.paymentStatus.name}
                                        statusId={order.paymentStatus.paymentStatusId}
                                        chipSize={"l"} />
                                </>
                                : <></>
                        }
                    </div>
                    <div style={{ display: 'flex', gap: '0.25rem', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', gap: '0.25rem' }}>
                            <BarekamText variant={"m"} width={'unset'} overflow={'unset'} opaque>
                                <Message messageKey={'invoice'} sectionId={MessageSections.ORDERS} />:
                            </BarekamText>
                            <BarekamText variant={"m"} width={'unset'} overflow={'unset'}>
                                {order.internalTrackingNumber}
                            </BarekamText>
                        </div>
                        {order.paymentStatus?.paymentStatusId === OrderPaymentStatusEnum.PAID
                            ?
                            <div style={{ display: 'flex', gap: '0.25rem' }}>
                                <BarekamText variant={"m"} width={'unset'} overflow={'unset'} opaque>
                                    <Message messageKey={'date'} sectionId={MessageSections.ORDERS} />:
                                </BarekamText>
                                <BarekamText variant={"m"}>
                                    {order.paymentInfo
                                        ? moment(order.paymentInfo.date).format('DD/MM/YYYY HH:mm')
                                        : ''
                                    }
                                </BarekamText>
                            </div>
                            : <></>
                        }
                    </div>
                    <BarekamButton type={SimpleButtons.TEXT} onClick={() => onActionClick()}>
                        <GapContainer>
                            <BarekamIcon variant={OrderIcons.printLabel} />

                            <BarekamText variant={"m"} width={'unset'} overflow={'unset'}>
                                <Message messageKey={outletContext.isWarehouseWorker ? 'print_blank_for_warehouse' : 'print_blank'} sectionId={MessageSections.ORDERS} />
                            </BarekamText>
                        </GapContainer>
                    </BarekamButton>
                </PaymentDetailsBlock>
                <PaymentDetailsRightBlock>
                    <div style={{ display: 'flex', gap: '0.25rem' }}>
                        <BarekamText variant={"m"} width={'unset'} overflow={'unset'} opaque>
                            <Message messageKey={'shipping'} sectionId={MessageSections.ORDERS} />:
                        </BarekamText>
                        <BarekamText variant={"m"}>
                            {order.paymentInfo?.shippingAmount} <Message messageKey={'amd'}
                                sectionId={MessageSections.ORDERS} />
                        </BarekamText>
                    </div>
                    <div style={{ display: 'flex', gap: '0.25rem' }}>
                        <BarekamText variant={"m"} width={'unset'} overflow={'unset'} opaque>
                            <Message messageKey={'discount'} sectionId={MessageSections.ORDERS} />:
                        </BarekamText>
                        <BarekamText variant={"m"}>
                            {order.paymentInfo?.appliedDiscount || 0} <Message messageKey={'amd'}
                                sectionId={MessageSections.ORDERS} />
                        </BarekamText>
                    </div>
                    <div style={{ display: 'flex', gap: '0.25rem' }}>
                        <BarekamText variant={"m"} width={'unset'} overflow={'unset'} opaque>
                            <Message messageKey={'additional_services'} sectionId={MessageSections.ORDERS} />:
                        </BarekamText>
                        <BarekamText variant={"m"}>
                            {paymentAmount.additionalServices} {paymentAmount.currency?.name[languageId]}
                        </BarekamText>
                    </div>
                    <div style={{ display: 'flex', gap: '0.25rem' }}>
                        <BarekamText variant={"m"} width={'unset'} overflow={'unset'} opaque>
                            <Message messageKey={'total'} sectionId={MessageSections.ORDERS} />:
                        </BarekamText>
                        <BarekamText variant={"m"} bold>
                            {paymentAmount.total} {paymentAmount.currency?.name[languageId]}
                        </BarekamText>
                    </div>
                </PaymentDetailsRightBlock>
            </div>
            <ToastContainer />
            <WarningDialog open={popupOpened}
                handleClose={() => {
                    setPopupOpened(false);
                }}
                titleKey={'paid_successfully'}
                descriptionIcon={<BarekamIcon variant={OrderIcons.paymentSuccessful} />}
                descriptionKey={'paid_successfully_description'} />

                <PayConfirmDialog open={confirmPopup} setOpen={setConfirmPopup} order={order} setPaymentPopupOpened={setPopupOpened} />
        </PaymentDetailsContainer>
    )
}

export default PaymentDetails;

interface PaymentDetailsProps {
    order: OrderModel,
    loadAndSetOrder: () => void,
}
